import { TrustGroupType } from "@/models/enum/trustGroupType";
import { UserProfileType } from "@/models/enum/userProfileType";
import { getAuthenticationStatus } from "@/services/authService";
import { defineStore } from "pinia";

export interface IAuthenticationState {
  authenticated: boolean;
  context: string;
  email: string;
  registered: boolean;
  roles: Array<string>;
  token: string;
  tokenSent: boolean;
  useSSO: boolean;
  inOnboarding: boolean;
}

export const useAuthenticationStore = defineStore("authentication", {
  state: (): IAuthenticationState => ({
    authenticated: false,
    context: "",
    email: "",
    registered: false,
    roles: [],
    token: "",
    tokenSent: false,
    useSSO: false,
    inOnboarding: false,
  }),

  actions: {
    async getAuthenticationStatus() {
      try {
        const response = await getAuthenticationStatus();
        this.authenticated = response.authenticated;
        this.registered = response.registered;
        this.roles = response.roles;
        this.useSSO = response.useSSO;
      } catch (error) {
        this.authenticated = false;
        this.roles = [];
        this.registered = false;
      }
    },

    setContext() {
      const params = new URLSearchParams(window.location.search);
      this.context = params.get("context") || params.get("contextId") ||"";
    },
    setAuthenticated(isAuthenticated: boolean) {
      this.authenticated = isAuthenticated;
    },
    canAccessCustomerDashboard(): boolean {
      return this.isChannel2Customer || this.isSuperUser;
    },

    canAccessReports(): boolean {
      return this.isChannel2Customer || this.isSuperUser;
    },

    canAccessCustomerTermsAndConditions(): boolean {
      return this.isChannel2Customer || this.isSuperUser;
    },

    canCreateQuestionnaires(): boolean {
      return this.isChannel2Customer || this.isSuperUser;
    },

    canEditQuestionnaires(): boolean {
      return this.isChannel2Customer || this.isSuperUser;
    },

    canUploadBusinessPartners(): boolean {
      return this.isChannel2Customer || this.isSuperUser || this.isAdmin;
    },

    canDownloadCustomerExcelTemplate(): boolean {
      return this.isChannel2Customer || this.isSuperUser;
    },

    canAccessDetailedRiskPage(): boolean {
      return this.isChannel2Customer || this.isSuperUser;
    },

    canAccessUnitProfile(): boolean {
      return this.isChannel2Customer || this.isSuperUser;
    },
  },
  getters: {
    isAdmin(state): boolean {
      return state.roles.includes(UserProfileType.Administrator);
    },

    isSuperUser(state): boolean {
      return state.roles.includes(UserProfileType.SuperUser);
    },

    hasContext(state): boolean {
      return !!state.context;
    },
    isChannel2Customer(state): boolean {
      return state.roles.includes(TrustGroupType.Channel2Customer);
    },
  },
});
